import * as React from 'react';
import  './fileitem.scss';

export interface IProps{
    pagedataload;
    currentpos;
    lastpageno;
}
export default class FilePagging extends React.Component<IProps> {
    
    constructor(props) {
        super(props);
      }
    
    public render() {
        return (
            <div className='files'>
                <div className="pagging">
                    {this.props.currentpos>0?
                    <React.Fragment>
                        <i onClick={()=>{this.props.pagedataload(0)}} className="ms-Icon ms-Icon--ChevronLeftEnd6 first" title="First" /> 
                        <i onClick={()=>{this.props.pagedataload(this.props.currentpos-1)}} className="ms-Icon ms-Icon--ChevronLeftSmall prev" title="previous" /> 
                    </React.Fragment>
                    :
                     <React.Fragment>
                        <i  className="ms-Icon ms-Icon--ChevronLeftEnd6 first disable" /> 
                        <i  className="ms-Icon ms-Icon--ChevronLeftSmall prev disable" /> 
                    </React.Fragment>
                    }
                    <span className="pageno">{this.props.currentpos+1}</span>
                    {this.props.currentpos==this.props.lastpageno-1?<i className="ms-Icon ms-Icon--ChevronRightSmall next disable"  /> 
                    :<i onClick={()=>{this.props.pagedataload(this.props.currentpos+1)}} className="ms-Icon ms-Icon--ChevronRightSmall next" title="Next" /> 
                    }
                    
                </div>
            </div>
        );
      }
}